import { useLanguage } from '../i18n/LanguageContext';

const EMAIL = 'turanfurkan783@gmail.com';

function ContactSection() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="contact">
      <div className="eyebrow rv">{t.contact.eyebrow}</div>
      <h2 className="contact-title rv-clip">
        {t.contact.heading} <span className="dim">{t.contact.heading2}</span>
      </h2>
      <div className="contact-actions rv rv-1">
        <a href={`mailto:${EMAIL}`} className="btn btn-acc btn-lg">
          {EMAIL} ↗
        </a>
        <a href="https://github.com/Furkanturan8" target="_blank" rel="noreferrer" className="btn btn-line btn-lg">
          GitHub
        </a>
        <a href="https://www.linkedin.com/in/furkan-turan-3b7713245/" target="_blank" rel="noreferrer" className="btn btn-line btn-lg">
          LinkedIn
        </a>
      </div>
    </section>
  );
}

export default ContactSection;
